import { useToast } from 'primevue';

// Response can be either an AxiosResponse or an AxiosError.
// (AxiosError tends to be if there is a 404)
// But AxiosError for whatever reason does not have an
// established Type, so lets just combine them w/ the
// properties we need.
export interface ErrorResponse {
  code?: string;
  message?: string;
  response?: {
    data?: {
      message?: string;
    };
    status?: number;
  };
  data?: {
    message?: string;
  };
  status?: number;
}

export interface SuccessResponse {
  data?: {
    success?: boolean;
    message?: string;
  };
}

export function useToastStore() {
  const toast = useToast();

  const successAll = (responses: Array<SuccessResponse>) => {
    let result = true;
    responses.forEach((resp) => {
      if (resp.data?.success === false) {
        result = false;
      }
    });
    return result;
  };

  const success = (response: SuccessResponse, life = 3000) => {
    // May also be a 200 with an Error message if the request
    // technically goes through but isn't permitted.
    const summary = response.data?.success ? 'Success' : 'Error';
    toast.add({
      severity: response.data?.success ? 'success' : 'error',
      summary,
      detail: response.data?.message,
      life,
    });
    return response.data?.success;
  };

  const error = (response: ErrorResponse, life = 3000) => {
    const summary = response.status ? `Error: ${response.status}` : `Error`;
    let detail = '';

    if (response.response && response.response.data) {
      if (response.response.data.message) {
        detail = response.response.data?.message;
      }
    } else if (response.message) {
      detail = response.message;
    }

    toast.add({ severity: 'error', summary, detail, life });
  };

  return {
    error,
    success,
    successAll,
  };
}
